module.exports = __webpack_public_path__ + "assets/0e1037076f73b46c31de6ed26d0f186a.mp3";